import React, { useState, useEffect } from "react";

import {
    Grid, TextField, FormHelperText, Typography, Box, Autocomplete, Chip, useMediaQuery,
    Select, MenuItem, Button, Stack, ToggleButtonGroup, ToggleButton,
} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import { useTheme } from '@mui/material/styles';
import { useLocation } from "react-router-dom";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import RemoveIcon from "@mui/icons-material/RemoveCircleOutlineSharp";

import * as CONSTANTS from "../../constants"

import { 
    view_wotageishi_namelist,
    view_organization_namelist,
    import_organization_data,
} from "../../services/topic_view";


const FillInForm = ({ formik, lang }) => {

    const location = useLocation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    const [countryList, setCountryList] = useState(CONSTANTS.COUNTRY_LIST);

    const [teamLeader, setTeamLeader] = useState(null);
    const [keyMembers, setKeyMembers] = useState([]);
    const [wotageishis, setWotageishis] = useState([]);
    const [country, setCountry] = useState(null);

    const [marking, setMarking] = useState('');
    const [markings, setMarkings] = useState(formik.values.markings);

    const [organizations, setOrganizations] = useState([]);
    const [targetOrganization, setTargetOrganization] = useState(null);
    const [currentOrganization, setCurrentOrganization] = useState(null);

    const updateTeamLeader = (wotageishi) => {
        setTeamLeader(wotageishi);
        if (wotageishi === null) {
            formik.values.team_leader_uid = 0;
            formik.values.team_leader_name = '';
        } else {
            formik.values.team_leader_uid = wotageishi.uid;
            formik.values.team_leader_name = wotageishi.name;
        }
    }

    const updateKeyMembers = (wotageishis) => {
        setKeyMembers(wotageishis);
        let key_members_uids = [];
        let key_members_names = [];
        wotageishis.forEach(wotageishi => {
            key_members_uids.push(wotageishi.uid);
            key_members_names.push(wotageishi.name)
        })
        formik.values.key_members_uids = key_members_uids;
        formik.values.key_members_names = key_members_names;
    }

    const updateCountry = (country) => {
        setCountry(country);
        if (country === null) {
            formik.values.region = '';
        } else {
            formik.values.region = country.code;
        }
    }

    const updateOrganizationUid = (organization) => {
        setTargetOrganization(organization);
        if (organization === null) {
            formik.values.organization_uid = 0;
        } else {
            formik.values.organization_uid = organization.uid;
        }
    }

    function filterCountries(countries, letter) {
        letter = letter.toLowerCase();
        var filteredCountries = countries.filter(function(item) {
           return item.label[lang].toLowerCase().startsWith(letter);
        });
        return filteredCountries;
    }

    const updateMarkings = (markings) => {
        setMarkings(markings);
        formik.values.markings = markings;
        setMarking('');
    }

    const updateWotageishiTextField = (newValue) => {
        fetchWotageishis(newValue);
    }
    const updateOrganizationTextField = (newValue) => {
        fetchOrganizations(newValue);
    }

     const fetchWotageishis = async (name) => {
        const [status, result] = await view_wotageishi_namelist(lang, name)
        if (status === 200) {
            setWotageishis(result.wotageishis);
        }
    };

    const fetchOrganizations = async (name) => {
        const [status, result] = await view_organization_namelist(lang, name)
        if (status === 200) {
            setOrganizations(result.organizations);
        }
    };

    const fetchOrganizationDataByUid = async (uid) => {
        const [status, result] = await import_organization_data(lang, uid)
        if (status === 200) {
            setCurrentOrganization(result);
            autoFillFormik(result);
        }
    }

    // send api request for url changes
    useEffect(() => {
        lang = location.pathname.substring(1, 3);
        fetchWotageishis('');
        fetchOrganizations('');
    }, [location.pathname]);


    const UpdateDefaultName = (option) => {
        switch (option) {
            case 'en':
                formik.values.default_name = formik.values.name_en;
                break;
            case 'jp':
                formik.values.default_name = formik.values.name_jp;
                break;
            case 'tc':
                formik.values.default_name = formik.values.name_tc;
                break;
            case 'sc':
                formik.values.default_name = formik.values.name_sc;
                break;
        }
    }

    const autoFillFormik = (currentOrganization) => {
        if (currentOrganization === null) return
        
        // Update formik values one by one
        formik.values.name_en = currentOrganization.name.en;
        formik.values.name_jp = currentOrganization.name.jp;
        formik.values.name_tc = currentOrganization.name.tc;
        formik.values.name_sc = currentOrganization.name.sc;
        formik.values.default_name = currentOrganization.default_name;
        formik.values.region = currentOrganization.region;
        formik.values.markings = currentOrganization.markings;
        formik.values.official_account_youtube = currentOrganization.official_account.youtube;
        formik.values.official_account_bilibili = currentOrganization.official_account.bilibili;
        formik.values.official_account_x = currentOrganization.official_account.x;
        formik.values.key_members_uids = currentOrganization.key_members_uid;
        formik.values.key_members_names = currentOrganization.key_members_name;
        if (currentOrganization.team_leader_uid.length > 0) {
            formik.values.team_leader_uid = currentOrganization.team_leader_uid;
            formik.values.team_leader_name = currentOrganization.team_leader_name;
        }
        setMarkings(currentOrganization.markings);
        
    }

    const insertCountry = (region) => {
        const country_v = countryList.find(o => o.code===region);
        setCountry(country_v);
    }

    const insertTeamLeader = (team_leader_uid, team_leader_name) => {
        if (team_leader_uid === 0) {
            setTeamLeader(null);
        } else {
            setTeamLeader({
                uid: team_leader_uid, 
                name: team_leader_name
            });
        } 
    }

    const insertKeyMembers = (key_members_uid, key_members_name) => {
        const keyMembers_v = key_members_uid.map((key_member_uid, index) => ({
            uid: key_member_uid,
            name: key_members_name[index]
        }));
        setKeyMembers(keyMembers_v);
    }

    useEffect(()=>{
        insertCountry(formik.values.region);
    }, [formik.values.region])

    useEffect(()=>{
        insertTeamLeader(
            formik.values.team_leader_uid,
            formik.values.team_leader_name
        );
    }, [formik.values.team_leader_name])

    useEffect(()=>{
        insertKeyMembers(
            formik.values.key_members_uids,
            formik.values.key_members_names
        );
    }, [formik.values.key_members_names])

    const radioButtonMap = {
        'en': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang], 
        'jp': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang], 
        'tc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang],
        'sc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang], 
    };

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
                sm={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.ORGANIZATION_UID[lang].toUpperCase()}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.ORGANIZATION_UID[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    id="organizations-standard"
                    freeSolo
                    filterSelectedOptions
                    options={organizations}
                    onChange={(e, organization) =>updateOrganizationUid(organization)}
                    getOptionLabel={organization => organization.name}
                    renderTags={() => {}}
                    value={targetOrganization}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateOrganizationTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Box
                    name="Creator Result"
                    variant="outlined"
                    type="text"
                    fullWidth
                    sx={{p: 1, border: '1px solid grey', borderRadius: '5px' }}
                    
                >
                    <Typography
                        textAlign="center"
                    >
                        {targetOrganization? targetOrganization.uid: '---'}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                xs={12}
                textAlign={'center'}
                justifyContent={'center'}
            >
                <Button
                    variant="outlined"
                    disabled={formik.values.organization_uid===0}
                    onClick={()=> {
                        fetchOrganizationDataByUid(formik.values.organization_uid)
                    }}
                    sx={{
                        width: '50%'
                    }}
                >
                    {CONSTANTS.REQUEST_TOPIC.BUTTONS.LOAD_ORGANIZATION_DATA[lang]}
                </Button>
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.NAME[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >                  
                <TextField
                    name="English Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.EN[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_en && formik.errors.name_en)}
                    helperText={formik.errors.name_en && formik.errors.name_en}
                    onChange={(e) => {
                        formik.handleChange("name_en")(e);
                        if (formik.values.default_language === 'en') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_en}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="Japanese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.JP[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_jp && formik.errors.name_jp)}
                    helperText={formik.errors.name_jp && formik.errors.name_jp}
                    onChange={(e) => {
                        formik.handleChange("name_jp")(e);
                        if (formik.values.default_language === 'jp') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_jp}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >             
                <TextField
                    name="Traditional Chinese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.TC[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_tc && formik.errors.name_tc)}
                    helperText={formik.errors.name_tc && formik.errors.name_tc}
                    onChange={(e) => {
                        formik.handleChange("name_tc")(e);
                        if (formik.values.default_language === 'tc') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_tc}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >                   
                <TextField
                    name="Simplified Chinese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.SC[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_sc && formik.errors.name_sc)}
                    helperText={formik.errors.name_sc && formik.errors.name_sc}
                    onChange={(e) => {
                        formik.handleChange("name_sc")(e);
                        if (formik.values.default_language === 'sc') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_sc}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.DEFAULT_LANG[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >   
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }} >
                    {
                        isMobile?
                        <Select
                            value={formik.values.default_language}
                            onChange={(event) => {
                                UpdateDefaultName(event.target.value);
                                formik.setFieldValue('default_language', event.target.value);
                            }}
                            sx={{width: "100%"}}
                        >
                            {Object.keys(radioButtonMap).map((key, index) => (
                                <MenuItem
                                    value={key}
                                >
                                    {radioButtonMap[key]}
                                </MenuItem>
                            ))}
                        </Select>
                        :
                        <ToggleButtonGroup
                            orientation="horizontal"
                            color="primary"
                            value={formik.values.default_language}
                            onChange={(event) => {
                                UpdateDefaultName(event.target.value);
                                formik.setFieldValue('default_language', event.target.value);
                            }}
                            exclusive
                            sx={{
                                minHeight: 48,
                                padding: '4px',
                                borderRadius: '12px',
                                width: "100%",
                            }}
                        >
                            {Object.keys(radioButtonMap).map((key, index) => (
                                <ToggleButton
                                    key={key}
                                    value={key}
                                    disableIcon
                                    variant="plain"
                                    sx={{ px: 2, alignItems: 'center', width: '25%', p: 1.5, textAlign: 'center'}}
                                >{radioButtonMap[key]}</ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    }
                </Box>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                sm={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.OTHER[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.ORGANIZATION_DETAILS.TEAM_LEADER[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    id="wazarens-standard"
                    freeSolo
                    filterSelectedOptions
                    options={wotageishis}
                    onChange={(e, wotageishi) =>updateTeamLeader(wotageishi)}
                    getOptionLabel={wotageishi => wotageishi.name}
                    renderTags={() => {}}
                    value={teamLeader}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateWotageishiTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Box
                    name="Creator Result"
                    variant="outlined"
                    type="text"
                    fullWidth
                    sx={{p: 1, border: '1px solid grey', borderRadius: '5px' }}
                    
                >
                    <Typography
                        textAlign="center"
                    >
                        {teamLeader !== null? teamLeader.name: '---'}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.ORGANIZATION_DETAILS.KEY_MEMBERS[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    multiple
                    id="wazarens-standard"
                    freeSolo
                    filterSelectedOptions
                    options={wotageishis}
                    onChange={(e, wotageishi) =>updateKeyMembers(wotageishi)}
                    getOptionLabel={wotageishi => wotageishi.name}
                    renderTags={() => {}}
                    value={keyMembers}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateWotageishiTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        keyMembers.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option.name || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateKeyMembers(keyMembers.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_FILTER.COUNTRY[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Autocomplete
                    id="organizations-standard"
                    freeSolo
                    filterSelectedOptions
                    options={countryList}
                    onChange={(e, newValue) => {updateCountry(newValue)}}
                    getOptionLabel={country => country.label[lang]}
                    renderTags={() => {}}
                    value={country}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e, newValue) => {setCountryList(filterCountries(CONSTANTS.COUNTRY_LIST, e.target.value))}}
                    />
                    )}
                />
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Box
                    name="Creator Result"
                    variant="outlined"
                    type="text"
                    fullWidth
                    sx={{p: 1, border: '1px solid grey', borderRadius: '5px' }}
                >
                    <Typography
                        textAlign="center"
                    >
                        {country? country.label[lang]: '---'}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.MARKINGS[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <TextField
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.MARKINGS[lang]}
                    value={marking}
                    onChange={(e) => {
                        setMarking(e.target.value);
                    }}
                    sx={{
                        width: '100%'
                    }}
                    InputProps={{
                        endAdornment: 
                        <Button 
                            variant="contained"
                            onClick={() => {
                                if (marking !== '') updateMarkings([...markings, marking]);
                            }}
                            sx={{
                                height: '100%'
                            }}
                        >
                            <SendIcon />
                        </Button>
                    }}
                />
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        markings.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateMarkings(markings.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                sm={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.WOTAGEISHI_DETAILS.SOCIAL_MEDIA[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    YouTube
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >       
                <TextField
                    name="YouTube"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.YOUTUBE[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_youtube && formik.errors.official_account_youtube)}
                    onChange={formik.handleChange('official_account_youtube')}
                    value={formik.values.official_account_youtube}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    Bilibili
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="Bilibili"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.BILIBILI[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_bilibili && formik.errors.official_account_bilibili)}
                    onChange={formik.handleChange('official_account_bilibili')}
                    value={formik.values.official_account_bilibili}
                />
            </Grid>
            <Grid
                item
                xs={4}
                sm={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    X
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={8}
                alignContent={'center'}
                pr={2}
            >                  
                <TextField
                    name="X"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.X[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_x && formik.errors.official_account_x)}
                    onChange={formik.handleChange('official_account_x')}
                    value={formik.values.official_account_x}
                />
            </Grid>
            
            {formik.errors.submit && (
                <Grid
                    item
                    xs={12}
                    sm={12}
                >
                <FormHelperText error>
                    {formik.errors.submit}
                </FormHelperText>
                </Grid>
            )}
        </Grid>
    )
}

export default FillInForm;